

















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import { UsersModule } from '@/store/Settings/UsersModule';
import { RolesModule } from '@/store/Settings/RolesModule';
import UpdateUserRolesRequest from '@/models/Settings/Users/UpdateUserRolesRequest';
import PageNames from '@/router/PageNames';

@Component({ name: 'UserRolesEdit' })
export default class extends SaascadaVueDialog {

    request: UpdateUserRolesRequest = new UpdateUserRolesRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateUserRolesRequest();
            const user = UsersModule.user;
            this.request.globalAdmin = user.globalAdmin;

            if (user.roles) {
                for (let index = 0; index < user.roles.length; index++) {
                    this.request.roleIds.push(user.roles[index].id);
                }
            }
        }
    }

    get roles() {
        return RolesModule.roles;
    }

    get showGlobalAdmin() {
        return AuthModule.me.globalAdmin;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            await UsersModule.editUserRoles(this.request);

            // We need to redirect because the edit response gives no data back
            // and it will look wrong if we still show the old data after editing
            if (UsersModule.user.id === AuthModule.me.id) {
                // If the logged in user is the user we are editing then log out completely
                this.$router.push({ name: PageNames.Login });
            }
            else {
                // Otherwise just redirect back to the main users page
                this.$router.push({ name: PageNames.Users });
            }
        }
    }

}
